import React, { useState } from "react";
import styled from "styled-components";

import Check from '../../image/CheckImage.png';


export default function TeacherBox(props) {
  const { data, index, isLast, isClicked, onClickTeacherBox } = props;

  const [isHover, setIsHover] = useState(false);

  function decideFontColor() {
    if (isHover) return '#FFFFFF';
    else if (isClicked) return '#FF8B48';
    else return '#000000';
  }

  return (
    <TeacherBoxView
      key={'Teachers-' + index}
      isLast={isLast}
      isHover={isHover}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onClickTeacherBox(data)}>
      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={decideFontColor()} cursor='pointer'>{data.teacherName}</Text>
      <CheckImage src={Check} isClicked={isClicked}/>
    </TeacherBoxView>
  )
}


const TeacherBoxView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 20px);
  min-height: ${props => props.isLast ? `32px` : `31px`};

  border-bottom: ${props => props.isLast ? `0px` : `1px solid #B2B2B2`};
  background-color: ${props => props.isHover ? `#FF8B48` : `#FFFFFF`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const CheckImage = styled.img`
  width: 12px;
  height: 12px;

  opacity: ${props => props.isClicked ? 1 : 0};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;